import { render } from "./SavedCartTable.vue?vue&type=template&id=b10bf4de"
import script from "./SavedCartTable.vue?vue&type=script&lang=js"
export * from "./SavedCartTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__